import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = ["disabled", "readonly"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = ["disabled", "readonly"]
const _hoisted_17 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = ["disabled", "readonly"]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "form-floating d-flex" }
const _hoisted_24 = ["disabled", "readonly"]
const _hoisted_25 = {
  key: 0,
  class: "position-absolute col-12 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden"
}
const _hoisted_26 = { class: "d-flex flex-row align-items-center text-secondary text-truncate" }
const _hoisted_27 = { class: "flag-box mt-1" }
const _hoisted_28 = { class: "country-name ms-2" }
const _hoisted_29 = {
  key: 1,
  class: "form-floating btn-group flex-fill d-flex"
}
const _hoisted_30 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden"
}
const _hoisted_31 = { class: "d-flex flex-row align-items-center text-secondary text-truncate" }
const _hoisted_32 = { class: "flag-box mt-1" }
const _hoisted_33 = { class: "country-name ms-2" }
const _hoisted_34 = { class: "dropdown-menu scrollable-menu dropdown-menu-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["id"]
const _hoisted_37 = { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }
const _hoisted_38 = { class: "flag-box mt-1" }
const _hoisted_39 = { class: "country-name ms-2" }
const _hoisted_40 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_41 = { class: "form-floating" }
const _hoisted_42 = ["disabled", "readonly"]
const _hoisted_43 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_44 = { class: "form-floating" }
const _hoisted_45 = ["disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title mb-0" }, [
          _createElementVNode("i", { class: "fas fa-home fa-fw me-2" }),
          _createElementVNode("span", null, "Dirección")
        ], -1)),
        _createElementVNode("div", null, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
                  class: "btn btn-sm btn-outline-danger me-2"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                  _createTextVNode("Cancelar ", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                  disabled: _ctx.saving,
                  class: "btn btn-sm btn-outline-success"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                  _cache[13] || (_cache[13] = _createTextVNode("Guardar ", -1)),
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit())),
                  class: "btn btn-sm btn-outline-secondary"
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "fas fa-pen fa-fw" }, null, -1)
                ]))])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "street",
                ref: "street",
                placeholder: "Calle y Número",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localAddress.street) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_12), [
                [_vModelText, _ctx.localAddress.street]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "street",
                class: "opacity-100"
              }, "Calle y Número", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "neighborhood",
                placeholder: "Colonia",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localAddress.neighborhood) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_16), [
                [_vModelText, _ctx.localAddress.neighborhood]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "neighborhood",
                class: "opacity-100"
              }, "Colonia", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "city",
                placeholder: "Ciudad",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localAddress.city) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_19), [
                [_vModelText, _ctx.localAddress.city]
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                for: "city",
                class: "opacity-100"
              }, "Ciudad", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                      style: {"color":"transparent !important"},
                      id: "country",
                      placeholder: "País",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.displayedCountry.spanish) = $event)),
                      disabled: !_ctx.editMode,
                      readonly: !_ctx.editMode
                    }, null, 10, _hoisted_24), [
                      [_vModelText, _ctx.displayedCountry.spanish]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      for: "country",
                      class: "opacity-100"
                    }, "País", -1)),
                    (_ctx.displayedCountry.alpha2Code)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, [
                              _createElementVNode("span", {
                                class: _normalizeClass('d-block flag ' + _ctx.displayedCountry.alpha2Code)
                              }, null, 2)
                            ]),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.displayedCountry.spanish), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["form-control flex-fill d-flex rounded-0 rounded-start text-center", _ctx.readOnlyClasses]),
                    type: "text",
                    id: "address-country",
                    style: {"color":"transparent !important"},
                    placeholder: "País",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.displayedCountry.spanish) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.displayedCountry.spanish]
                  ]),
                  (_ctx.displayedCountry.alpha2Code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, [
                            _createElementVNode("span", {
                              class: _normalizeClass('d-block flag ' + _ctx.displayedCountry.alpha2Code)
                            }, null, 2)
                          ]),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.displayedCountry.spanish), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _cache[21] || (_cache[21] = _createElementVNode("button", {
                    type: "button",
                    class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Paises")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_34, [
                    _createElementVNode("li", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDisplayedCountry({})))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createStaticVNode("<button class=\"dropdown-item country text-muted\" id=\"item-tlgm-clear\"><span class=\"row\"><span class=\"dial-code text-center col-2 ps-0\"><i class=\"far fa-trash-alt fa-fw\"></i></span><span class=\"col d-flex flex-row align-items-center fw-lighter ps-0\"><span class=\"country-name ms-2\"> Limpiar </span></span></span></button>", 1)
                    ]))]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.starredCountries, (country) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: country.alpha3code,
                        onClick: ($event: any) => (_ctx.setDisplayedCountry(country))
                      }, [
                        _createElementVNode("button", {
                          class: "dropdown-item country",
                          id: 
                        'item-' +
                        country.alpha2Code.toLowerCase() +
                        '-preferred'
                      
                        }, [
                          _createElementVNode("span", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, [
                              _createElementVNode("span", {
                                class: _normalizeClass('d-block flag ' + country.alpha2Code)
                              }, null, 2)
                            ]),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(country.spanish), 1)
                          ])
                        ], 8, _hoisted_36)
                      ], 8, _hoisted_35))
                    }), 128))
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    for: "country",
                    class: "opacity-100"
                  }, "País", -1))
                ]))
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "state",
                placeholder: "Estado",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localAddress.state) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_42), [
                [_vModelText, _ctx.localAddress.state]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "state",
                class: "opacity-100"
              }, "Estado", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-center", _ctx.readOnlyClasses]),
                id: "zipcode",
                placeholder: "Código Postal",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localAddress.zipCode) = $event)),
                disabled: !_ctx.editMode,
                readonly: !_ctx.editMode
              }, null, 10, _hoisted_45), [
                [_vModelText, _ctx.localAddress.zipCode]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "zipcode",
                class: "opacity-100"
              }, "Código Postal", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}